import { version } from '../version.js';
export const getVersion = () => `wagmi@${version}`;
//# sourceMappingURL=getVersion.js.map